import React from "react";
import { Container, Flex, Tile, Title, TilesContainer, Text } from "../ui";
import { SVGCarousel, TileList, ContactBox } from "../components";
import { WindowSize } from "react-fns";
import styled from "styled-components";
import { LETSTALK } from "../assets/svg";
import { RollFromBottom, RollFromLeft, Marquee } from "../ui/animations";
import InlineSVG from "svg-inline-react";
import { SVGMarquee } from "../components/";

const TeamContainer = styled(Container)`
  /* height: calc(100vh - 200px); */
  padding-bottom: 10rem;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  .location {
    animation: ${RollFromBottom} 1.75s ease;
  }
  > div {
    @media (max-width: 1200px) {
      flex-direction: column;
    }
  }
  .svg--wrapper {
    width: 80vw;
    position: relative;
    svg {
      position: absolute;
      animation: ${Marquee} 33.75s linear infinite;
      /* width: 50vw; */
    }
  }
  .contact--container {
    z-index: 10;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

const Team = () => {
  return (
    <WindowSize
      render={({ width }) => (
        <>
          <TilesContainer>
            {width >= 769 ? (
              <>
                <div className="svg--wrapper">
                  <InlineSVG src={LETSTALK} />
                </div>
                <Tile style={{ flex: 0.5 }} />
                <Tile />
                <Tile />
                <Tile />
                <Tile />
                <Tile />
                <Tile style={{ flex: 0.5 }} />
              </>
            ) : (
              <>
                <div className="svg--wrapper">
                  <InlineSVG src={LETSTALK} />
                </div>
                <Tile />
                <Tile />
                <Tile />
              </>
            )}
          </TilesContainer>
          <TeamContainer padding="5rem 2rem">
            <Flex justifyContent="flex-start">
                <div className="contact--container">
                    <Title>Contact Us</Title>
                    <div className="location">
                        <h4>Belgrade</h4>
                        <p>Dimitrija Tucovića 89</p>
                        <p>
                            <a style={{textDecoration: "none", color: "white", cursor: "pointer"}} href="mailto:office@uon.rs">office@uon.rs</a>
                        </p>
                        <p>
                            <a style={{textDecoration: "none", color: "white", cursor: "pointer"}} href="tel:381-63-595-055">+381 63 595 055</a>
                        </p>
                    </div>
                </div>
              <ContactBox style={{ flex: 1 }} />
            </Flex>
          </TeamContainer>
        </>
      )}
    />
  );
};
export default Team;
